<template>
  <div>
    <v-sheet class="ma-5 rounded text-center">
      <h1 class="pa-2">برد '{{ detail.board.name }}'</h1>
      <div
        style="position: absolute; left: 50px; top: 44px"
        @click="detail.en = false"
      >
        <svg
          width="44"
          height="44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="44" height="44" rx="22" class="back-btn" />
          <path
            d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z"
            fill="black"
          />
          <path
            d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z"
            fill="black"
          />
        </svg>
      </div>
    </v-sheet>
    <v-card class="elevation-0">
      <v-card-text>
        <v-select
            v-if="detail.type==='report'"
            v-model="report_date"
            :items="report_date_items"
            label="بازه زمانی"
        ></v-select>

        <v-row v-if="detail.type==='degree'">
            <BoardDegree
                v-for="device in detail.board.devices"
                style="max-width: 100%"
                :device="device"
                :board_id="detail.board.id"
                :set="get_set(device.name)"
                class="pt-10 mt-10"
            ></BoardDegree>
        </v-row>
        <v-row v-else>
          <BoardReport
              v-for="device in detail.board.devices"
              :device="device"
              :board_id="detail.board.id"
              :set="get_set(device.value)"
              :date_range="report_date"
          />
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<style>
.gauge-title{
  font-size: 2em;
}
</style>

<script>
import axios from "axios";
import BoardReport from "./report.vue";
import BoardDegree from "@/components/admin/devices_data/degree.vue";

export default {
  name: "BoardDetail",
  props: ["detail"],
  components: { BoardDegree, BoardReport },

  data: () => ({
    key: localStorage.getItem("key"),
    report_date:'۱ روزه گذشته',
    // Devices
    devices_data: {},
    //Chart
    chartData: {},
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
    report_date_items:[
        '۶ ساعت گذشته',
        '۱۲ ساعت گذشته',
        '۱ روزه گذشته',
        '۱ هفته گذشته',
        '۲ هفته گذشته',
        '۳ هفته گذشته',
        '۱ ماه گذشته',
        '۳ ماه گذشته',
        '۶ ماه گذشته',
        '۱ سال گذشته',
    ],
    charts: [],
    headers: [
      // {text: 'شماره',align: 'center', value: 'id'},
      { text: "مقدار", align: "center", value: "_value" },
      { text: "زمان ثبت", align: "center", value: "_time" },
    ],
  }),
  // watch: {
  //   detail: {
  //     immediate: true,
  //     handler(newVal, oldVal) {
  //       if (this.detail.en) {
  //         this.get_datas();
  //       }
  //     },
  //   },
  // },

  methods: {
    get_set(device){
      console.log(this.detail.board.sets)
      console.log(device)
      const set_filtered = this.detail.board.sets.filter(set => set.name === device);
      console.log(set_filtered)
      if(set_filtered.length === 0)
        return false
      return set_filtered[0]
    },
    get_datas() {
      for (let i = 0; i < this.detail.board.devices.length; i++) {
        this.fetch_data(this.detail.board.devices[i].value);
      }
    },
    fetch_data(field_name) {
      axios
        .get(
          `${this.BACKEND_LINK}/api/devices-data/device/?pk=${this.detail.board.id}&device=S&field_name=${field_name}`,
          {
            headers: { Authorization: `Token ${this.key}` },
          }
        )
        .then((response) => {
          this.charts.push({
            labels: response.data.map(
              (a) => new Date(a._time).toLocaleString("fa-ir").split(",")[1]
            ),
            datasets: [
              {
                label: field_name,
                backgroundColor: "#D20003",
                data: response.data.map((a) => a._value),
              },
            ],
          });
        })
        .catch((error) => {
          this.$snotify.error(
            "خطا در دریافت اطلاعات",
            `کد ${error.response.status}‍‍‍`
          );
        });
    },
  },
};
</script>
